import { IEntityFragment, IMappingProfile } from '@pf/shared-common';
import {
    FragmentMappingConfig,
    InteroperableMetadata,
    InteroperableMetadataMap,
} from '../fragment-mapping-config';
import { PlatformWmsFragments } from './platform-wms-fragments.enum';

export interface IPickListFragment extends IEntityFragment {
    id: string;
    status: string;
    pickByDate: string;
    organizedBy: string;
    assignedTo: string;
}

export type IPickListFragmentDto = IPickListFragment;

export function PickListFragmentMetadataMap<
    TFragmentDto extends IPickListFragmentDto,
    TFragment extends IPickListFragment,
>(config: FragmentMappingConfig<TFragmentDto, TFragment>): IMappingProfile {
    const interoperableMetadata = {
        status: String,
        pickByDate: String,
        organizedBy: String,
        assignedTo: String,
    } as InteroperableMetadata<TFragmentDto, TFragment>;
    return InteroperableMetadataMap(
        PlatformWmsFragments.PickList,
        interoperableMetadata,
        config
    );
}

export const DefaultPickListFragmentMetadataMap = PickListFragmentMetadataMap<
    IPickListFragmentDto,
    IPickListFragment
>({});
